export const SET_ITEMS = 'app/product/SET_ITEMS';
